import React, { useRef } from "react";
import CreateTeamPage from "../../../page/createTeamPage";
import { useSelector } from "react-redux";
import { getCurrentUserInvitation } from "../../../store/invitations";
import PropTypes from "prop-types";
import ModalShell from "./ModalShell";
import { useI18n } from "../../../i18n/LanguageContext";

const CreateTeamModal = ({ onShowModal }) => {
  const invitation = useSelector(getCurrentUserInvitation());
  const { t } = useI18n();
  const closeRef = useRef(() => {});
  const requestClose = () => closeRef.current();

  return (
    <ModalShell onClose={() => onShowModal()} closeRef={closeRef}>
      <div className="rounded-xl">
        <div className="relative flex-auto">
          <div className="rounded-md bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500 p-1 sm:p-2">
            <div className="relative flex w-full min-w-0 flex-col rounded-lg border-0 bg-white shadow-lg outline-none">
              <div className="flex justify-center rounded-t border-b border-solid border-slate-200 bg-lime-100 px-4 py-4 sm:py-6">
                <h3 className="text-lg font-bold sm:text-xl">{t("team.title")}</h3>
              </div>
              {invitation !== undefined ? (
                <div className="flex justify-center p-4">
                  <p className="px-4 text-center font-bold">
                    {t("team.invited")}
                  </p>
                </div>
              ) : (
                <div className="min-w-0 p-2 sm:p-4">
                  <CreateTeamPage onShowModal={requestClose} />
                </div>
              )}
              <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-4 sm:p-6">
                <button
                  className="btn-smooth rounded-md bg-slate-100 px-6 py-2 text-sm font-bold uppercase text-red-300 outline-none hover:bg-slate-200 hover:text-red-500"
                  type="button"
                  onClick={requestClose}
                >
                  {t("common.close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

CreateTeamModal.propTypes = {
  onShowModal: PropTypes.func,
};

export default CreateTeamModal;
